import { render, staticRenderFns } from "./NicheAreaDetail.vue?vue&type=template&id=01fbf6ca&scoped=true"
import script from "./NicheAreaDetail.vue?vue&type=script&lang=js"
export * from "./NicheAreaDetail.vue?vue&type=script&lang=js"
import style0 from "./NicheAreaDetail.vue?vue&type=style&index=0&id=01fbf6ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbf6ca",
  null
  
)

export default component.exports